export default __webpack_public_path__ + "static/media/mw13.c8b1c683.webp";